package com.kinoshazam.uiKit.trailer

import androidx.compose.ui.graphics.Color
import kotlin.math.roundToInt

class TrailerBanner {
    var title: String = ""
    var rating: String = ""
    var countries: String = ""
    var genres: String = ""
    var playLabel: String = ""
    var trailerLabel: String = ""
    var favoriteLabel: String = ""
    var showPlay: Boolean = false
    var showTrailer: Boolean = false
    var favorite: Boolean = false
    var centered: Boolean = false
    var year: String = ""
    var overlayTopPx: Float = 0f
    var overlayLeftPx: Float = 0f
    var overlayWidthPx: Float = 0f
    var overlayTopDp: Float = 0f
    var overlayLeftDp: Float = 0f
    var overlayWidthDp: Float = 0f
    var actionsTopPx: Float = 0f
    var actionsLeftPx: Float = 0f
    var actionsWidthPx: Float = 0f
    var actionsTopDp: Float = 0f
    var actionsLeftDp: Float = 0f
    var actionsWidthDp: Float = 0f
    var onPlay: () -> Unit = {}
    var onTrailer: () -> Unit = {}
    var onFavorite: () -> Unit = {}
}

object TrailerControls {
    val banner = TrailerBanner()
    var onAudible: ((Boolean) -> Unit)? = null
    var onRelease: (() -> Unit)? = null
    var onFailed: (() -> Unit)? = null
    var onPlaying: (() -> Unit)? = null

    fun setAudible(audible: Boolean) {
        onAudible?.invoke(audible)
    }

    fun fail() {
        onFailed?.invoke()
    }

    fun playing() {
        onPlaying?.invoke()
    }

    fun release() {
        val release = onRelease
        onRelease = null
        release?.invoke()
    }
}

fun jsQuote(value: String): String =
    value.replace("\\", "\\\\").replace("'", "\\'").replace("\n", " ").replace("\r", " ")

fun trailerAudibleJs(audible: Boolean): String = """
    if (window.__ksTrailer) window.__ksTrailer.muted = ${!audible};
    if (window.ksSetAudible) window.ksSetAudible(${audible});
    var video = document.querySelector('video');
    if (video) {
      video.muted = ${!audible};
      if (video.paused) {
        try { var pending = video.play(); if (pending && pending.catch) pending.catch(function(){}); } catch (e) {}
      }
    }
    if (window.__ksTrailerApply) window.__ksTrailerApply();
"""

fun youtubeEmbedQuery(videoId: String): String =
    "autoplay=1&mute=1&controls=1&fs=1&rel=0" +
        "&modestbranding=1&playsinline=1&iv_load_policy=3&cc_load_policy=0" +
        "&loop=1&playlist=$videoId&enablejsapi=1"

fun youtubePlayerDocument(videoId: String): String = """
<!DOCTYPE html>
<html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
<style>html,body{margin:0;width:100%;height:100%;background:#000;overflow:hidden}#player{position:absolute;left:0;top:0;width:100%;height:100%;border:0}</style>
</head>
<body>
<iframe id="player" title="trailer" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" referrerpolicy="strict-origin-when-cross-origin"></iframe>
<script>
var player;
var wantAudible = false;
var expanded = false;
var failed = false;
var ready = false;
var frame = document.getElementById('player');
var src = 'https://www.youtube.com/embed/$videoId?${youtubeEmbedQuery(videoId)}';
if (location.origin && location.origin !== 'null') src += '&origin=' + encodeURIComponent(location.origin);
if (document.referrer) src += '&widget_referrer=' + encodeURIComponent(document.referrer);
frame.src = src;
function notifyHost(name) {
  var delivered = false;
  try {
    if (window.KinoshkaTrailer && window.KinoshkaTrailer[name]) {
      window.KinoshkaTrailer[name]();
      delivered = true;
    }
  } catch (e) {}
  try {
    if (window.kinoshkaHost && window.kinoshkaHost[name]) {
      window.kinoshkaHost[name]();
      delivered = true;
    }
  } catch (e) {}
  try {
    var ios = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosJsBridge;
    if (ios) {
      ios.postMessage(JSON.stringify({callbackId:-1, methodName:'trailer', params:name}));
      delivered = true;
    }
  } catch (e) {}
  try {
    var parent = window.parent;
    if (parent && parent !== window) {
      if (name === 'failed' && parent.ksTrailerFailed) {
        parent.ksTrailerFailed();
        delivered = true;
      }
      if (name === 'close' && parent.ksTrailerEscape) {
        parent.ksTrailerEscape();
        delivered = true;
      }
      if (name === 'playing' && parent.ksTrailerPlaying && parent.ksTrailerPlaying()) delivered = true;
    }
  } catch (e) {}
  return delivered;
}
function reportFailure() {
  notifyHost('failed');
}
function playerFrame() {
  try {
    if (player && typeof player.getIframe === 'function') return player.getIframe();
  } catch (e) {}
  return document.getElementById('player') || frame;
}
function failTrailer() {
  if (failed) return;
  failed = true;
  if (readyTimer) {
    clearTimeout(readyTimer);
    readyTimer = 0;
  }
  if (frame) frame.style.display = 'none';
  reportFailure();
}
function layoutChrome() {
  if (!frame || failed) return;
  frame.style.top = '0px';
  frame.style.height = expanded ? '100%' : 'calc(100% + 80px)';
}
function applySound() {
  if (failed || !player || typeof player.mute !== 'function' || typeof player.unMute !== 'function') return;
  if (wantAudible) {
    player.unMute();
    if (typeof player.setVolume === 'function') player.setVolume(100);
    if (typeof player.playVideo === 'function') player.playVideo();
  } else {
    if (typeof player.isMuted !== 'function' || !player.isMuted()) player.mute();
    var state = typeof player.getPlayerState === 'function' ? player.getPlayerState() : -1;
    if (state !== 1 && state !== 3 && typeof player.playVideo === 'function') player.playVideo();
  }
}
function onYouTubeIframeAPIReady() {
  player = new YT.Player('player', {
    events: {
      onReady: function (event) {
        ready = true;
        if (readyTimer) {
          clearTimeout(readyTimer);
          readyTimer = 0;
        }
        applySound();
        event.target.playVideo();
      },
      onStateChange: function (event) {
        if (event.data === 1) {
          applySound();
          reportPlaying();
        }
      },
      onError: function () {
        failTrailer();
      }
    }
  });
}
window.ksSetAudible = function (audible) {
  wantAudible = !!audible;
  applySound();
};
window.ksSetExpanded = function (open) {
  expanded = !!open;
  layoutChrome();
  if (expanded) setTimeout(releasePlayerFocus, 600);
};
window.ksPause = function () {
  if (player && player.pauseVideo) player.pauseVideo();
};
var playingReported = false;
function reportPlaying() {
  if (failed || playingReported) return;
  if (notifyHost('playing')) playingReported = true;
}
function releasePlayerFocus() {
  var node = playerFrame();
  try { if (node) node.blur(); } catch (e) {}
  try { window.focus(); } catch (e) {}
  try { if (window.parent && window.parent !== window) window.parent.focus(); } catch (e) {}
}
document.addEventListener('keydown', function (event) {
  if (!expanded || (event.key !== 'Escape' && event.key !== 'Esc')) return;
  event.preventDefault();
  event.stopPropagation();
  releasePlayerFocus();
  notifyHost('close');
}, true);
var focusedAt = 0;
setInterval(function () {
  if (!expanded || failed) {
    focusedAt = 0;
    return;
  }
  var node = playerFrame();
  if (!node || document.activeElement !== node) {
    focusedAt = 0;
    return;
  }
  var current = document.fullscreenElement || document.webkitFullscreenElement;
  if (current) return;
  if (!focusedAt) focusedAt = Date.now();
  if (Date.now() - focusedAt < 500) return;
  focusedAt = 0;
  releasePlayerFocus();
}, 100);
var playingTries = 0;
var playingWatch = setInterval(function () {
  if (playingReported || failed || ++playingTries > 40) {
    clearInterval(playingWatch);
    return;
  }
  var state = -1;
  try { if (player && player.getPlayerState) state = player.getPlayerState(); } catch (e) {}
  if (state === 1) reportPlaying();
}, 500);
layoutChrome();
frame.addEventListener('error', failTrailer);
var readyTimer = setTimeout(function () {
  if (!ready) failTrailer();
}, 10000);
var script = document.createElement('script');
script.src = 'https://www.youtube.com/iframe_api';
script.onerror = failTrailer;
document.head.appendChild(script);
</script>
</body>
</html>
"""

fun youtubeVideoId(url: String): String? {
    val value = url.trim()
    if (value.isEmpty()) return null
    val match = YOUTUBE_ID.find(value)
    if (match != null) return match.groupValues[1]
    return value.takeIf { YOUTUBE_BARE.matches(it) }
}

fun youtubeEmbedUrl(videoId: String): String =
    "https://www.youtube.com/embed/$videoId?${youtubeEmbedQuery(videoId)}"

fun Color.toCssRgba(): String {
    val redPart = (red * 255f).roundToInt().coerceIn(0, 255)
    val greenPart = (green * 255f).roundToInt().coerceIn(0, 255)
    val bluePart = (blue * 255f).roundToInt().coerceIn(0, 255)
    val alphaPart = ((alpha.coerceIn(0f, 1f)) * 1000f).roundToInt() / 1000f
    return "rgba($redPart,$greenPart,$bluePart,$alphaPart)"
}

fun trailerApplyJs(
    expand: Float,
    muted: Boolean,
    showBack: Boolean,
    showClose: Boolean,
    allowPull: Boolean,
    scrimCss: String,
): String {
    val stepped = (expand.coerceIn(0f, 1f) * 40f).roundToInt() / 40f
    val scrim = scrimCss.replace("'", "")
    return buildString {
        append("if (!window.__ksTrailerApply) {\n")
        append(TRAILER_BOOTSTRAP)
        append("\n}\n")
        append("window.__ksTrailer = {")
        append("expand:").append(stepped).append(",")
        append("muted:").append(muted).append(",")
        append("showBack:").append(showBack).append(",")
        append("showClose:").append(showClose).append(",")
        append("allowPull:").append(allowPull).append(",")
        val banner = TrailerControls.banner
        append("scrim:'").append(scrim).append("',")
        append("title:'").append(jsQuote(banner.title)).append("',")
        append("rating:'").append(jsQuote(banner.rating)).append("',")
        append("countries:'").append(jsQuote(banner.countries)).append("',")
        append("genres:'").append(jsQuote(banner.genres)).append("',")
        append("playLabel:'").append(jsQuote(banner.playLabel)).append("',")
        append("trailerLabel:'").append(jsQuote(banner.trailerLabel)).append("',")
        append("favoriteLabel:'").append(jsQuote(banner.favoriteLabel)).append("',")
        append("showPlay:").append(banner.showPlay).append(",")
        append("showTrailer:").append(banner.showTrailer).append(",")
        append("favorite:").append(banner.favorite).append(",")
        append("centered:").append(banner.centered).append(",")
        append("year:'").append(jsQuote(banner.year)).append("',")
        append("overlayTop:").append(banner.overlayTopDp).append(",")
        append("overlayLeft:").append(banner.overlayLeftDp).append(",")
        append("overlayWidth:").append(banner.overlayWidthDp).append(",")
        append("actionsTop:").append(banner.actionsTopDp).append(",")
        append("actionsLeft:").append(banner.actionsLeftDp).append(",")
        append("actionsWidth:").append(banner.actionsWidthDp)
        append("};\n")
        append("window.__ksTrailerApply();")
    }
}

private val YOUTUBE_ID = Regex("""(?:v=|youtu\.be/|embed/|shorts/)([A-Za-z0-9_-]{6,})""")
private val YOUTUBE_BARE = Regex("""[A-Za-z0-9_-]{6,}""")

private const val TRAILER_BOOTSTRAP = """
(function(){
  if (window.__ksTrailerApply) return;
  window.__ksTrailer = window.__ksTrailer || {expand:0, muted:true, showBack:false, showClose:false, allowPull:false, scrim:'rgba(2,10,36,1)'};
  var style = document.getElementById('ks-style');
  if (!style) {
    style = document.createElement('style');
    style.id = 'ks-style';
    style.textContent = 'html,body{background:#000!important;overflow:hidden!important;}';
    (document.head || document.documentElement).appendChild(style);
  }
  function ksCall(name, extra) {
    try {
      var host = window.KinoshkaTrailer;
      if (host && host[name]) {
        if (extra === undefined) host[name]();
        else host[name](String(extra));
      }
    } catch (e) {}
    try {
      var fx = window.kinoshkaHost;
      if (fx && fx[name]) {
        if (extra === undefined) fx[name]();
        else fx[name](String(extra));
      }
    } catch (e) {}
    try {
      var ios = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosJsBridge;
      if (ios) {
        var params = extra === undefined ? name : (name + ':' + extra);
        ios.postMessage(JSON.stringify({callbackId:-1, methodName:'trailer', params: params}));
      }
    } catch (e) {}
  }
  function button(id, glyph, action) {
    var node = document.getElementById(id);
    if (!node) {
      node = document.createElement('button');
      node.id = id;
      node.type = 'button';
      node.textContent = glyph;
      node.style.cssText = 'position:fixed;z-index:2147483647;top:12px;left:12px;width:44px;height:44px;border:0;border-radius:22px;background:rgba(2,10,36,0.55);color:#1A9FDF;font-size:28px;line-height:40px;text-align:center;padding:0;cursor:pointer;';
      node.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        ksCall(action);
      });
      (document.body || document.documentElement).appendChild(node);
    }
    return node;
  }
  function fromChrome(event) {
    var node = event.target;
    while (node) {
      if (node.id === 'ks-banner' || node.id === 'ks-actions' || node.tagName === 'BUTTON') return true;
      if (node.classList && (node.classList.contains('ytp-chrome-bottom') || node.classList.contains('ytp-chrome-top'))) return true;
      node = node.parentNode;
    }
    return false;
  }
  function renderBanner(state) {
    var banner = document.getElementById('ks-banner');
    if (!banner) {
      banner = document.createElement('div');
      banner.id = 'ks-banner';
      banner.style.cssText = 'position:fixed;z-index:2147483647;display:none;pointer-events:none;';
      (document.body || document.documentElement).appendChild(banner);
    }
    var open = (state.expand || 0) < 0.2 && (state.overlayWidth || 0) > 1;
    banner.style.display = open ? 'block' : 'none';
    if (!open) return;
    banner.style.top = (state.overlayTop || 0) + 'px';
    banner.style.left = (state.overlayLeft || 0) + 'px';
    banner.style.width = (state.overlayWidth || 0) + 'px';
    banner.style.textAlign = state.centered ? 'center' : 'left';
    var html = '';
    function esc(text) {
      return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
    }
    function line(text, color, size, weight, gap) {
      if (!text) return '';
      return '<div style="color:' + color + ';font-size:' + size + 'px;font-weight:' + weight + ';line-height:1.2;margin-top:' + gap + 'px;text-shadow:0 1px 8px rgba(0,0,0,0.65);">' + esc(text) + '</div>';
    }
    html += line(state.title, '#ffffff', 24, 700, 0);
    if (state.centered) {
      html += line(state.genres, '#ffffff', 14, 500, 4);
      html += line(state.rating, '#1A9FDF', 14, 500, 20);
      html += line(state.countries, '#ffffff', 14, 500, 4);
      html += line(state.year, '#ffffff', 14, 500, 4);
    } else {
      html += line(state.rating, '#1A9FDF', 14, 500, 12);
      html += line(state.countries, '#ffffff', 14, 500, 12);
      html += line(state.genres, '#ffffff', 14, 500, 12);
      html += line(state.year, '#ffffff', 14, 500, 12);
    }
    if (banner.getAttribute('data-html') !== html) {
      banner.setAttribute('data-html', html);
      banner.innerHTML = html;
    }
  }
  function renderActions(state) {
    var actions = document.getElementById('ks-actions');
    if (!actions) {
      actions = document.createElement('div');
      actions.id = 'ks-actions';
      actions.style.cssText = 'position:fixed;z-index:2147483647;display:none;pointer-events:none;';
      (document.body || document.documentElement).appendChild(actions);
    }
    var open = (state.expand || 0) < 0.2 && (state.actionsWidth || 0) > 1;
    actions.style.display = open ? 'flex' : 'none';
    if (!open) return;
    actions.style.top = (state.actionsTop || 0) + 'px';
    actions.style.left = (state.actionsLeft || 0) + 'px';
    actions.style.width = (state.actionsWidth || 0) + 'px';
    actions.style.flexWrap = 'wrap';
    actions.style.gap = '4px';
    actions.style.justifyContent = state.centered ? 'center' : 'flex-start';
    function esc(text) {
      return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
    }
    function icon(path, filled) {
      var fill = filled ? '#ffffff' : 'none';
      var stroke = filled ? 'none' : '#ffffff';
      return '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="2" stroke-linejoin="round"></path></svg>';
    }
    var playIcon = '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="#ffffff" stroke-width="2"></circle><path d="M9.5 15V9L15.5 12.086L9.5 15Z" fill="#ffffff"></path></svg>';
    var filmIcon = icon('M21.35 3H17.59C17.23 3 17.03 3.41 17.23 3.7L19.39 6.76C19.6 7.05 19.39 7.46 19.04 7.46H17.98C17.84 7.46 17.7 7.39 17.62 7.28L14.73 3.19C14.65 3.07 14.52 3 14.37 3H11.69C11.33 3 11.13 3.41 11.33 3.7L13.49 6.76C13.7 7.05 13.49 7.46 13.14 7.46H12.08C11.93 7.46 11.8 7.39 11.72 7.28L8.83 3.19C8.75 3.07 8.61 3 8.47 3H5.79C5.43 3 5.22 3.41 5.43 3.7L7.59 6.76C7.8 7.05 7.59 7.46 7.24 7.46H6.17C6.03 7.46 5.9 7.39 5.82 7.28L2.8 3H2.65C1.19 3 0 4.2 0 5.69V18.31C0 19.8 1.19 21 2.65 21H21.35C22.81 21 24 19.8 24 18.31V5.69C24 4.2 22.81 3 21.35 3Z', true);
    var star = 'M12 19.4L6.81 21.91C6.33 22.14 5.76 21.92 5.54 21.42C5.47 21.25 5.44 21.07 5.46 20.88L6.14 14.94L2.25 10.56C1.9 10.15 1.92 9.52 2.31 9.14C2.44 9.02 2.6 8.93 2.77 8.9L8.38 7.73L11.17 2.51C11.42 2.03 12.01 1.86 12.47 2.13C12.62 2.22 12.75 2.35 12.83 2.51L15.62 7.73L21.23 8.9C21.75 9 22.08 9.53 21.98 10.07C21.95 10.25 21.87 10.42 21.75 10.56L17.86 14.94L18.54 20.88C18.6 21.43 18.23 21.93 17.7 21.99C17.53 22.02 17.35 21.99 17.19 21.91L12 19.4Z';
    function pill(action, label, background, glyph, iconOnly) {
      var pad = iconOnly ? '0' : '0 16px';
      var width = iconOnly ? 'width:48px;' : '';
      var text = iconOnly ? '' : '<span>' + esc(label) + '</span>';
      return '<button type="button" data-act="' + action + '" style="height:48px;' + width + 'margin:0;padding:' + pad + ';border:0;border-radius:24px;background:' + background + ';color:#ffffff;font-weight:700;font-size:14px;display:inline-flex;align-items:center;justify-content:center;gap:6px;pointer-events:auto;cursor:pointer;">' + glyph + text + '</button>';
    }
    var html = '';
    if (state.showPlay) html += pill('play', state.playLabel, '#1A9FDF', playIcon, false);
    if (state.showTrailer) html += pill('trailer', state.trailerLabel, '#1B2942', filmIcon, false);
    html += pill('favorite', state.favoriteLabel, state.favorite ? '#1A9FDF' : '#1B2942', icon(star, !!state.favorite), !!state.showPlay);
    if (actions.getAttribute('data-html') !== html) {
      actions.setAttribute('data-html', html);
      actions.innerHTML = html;
      var buttons = actions.querySelectorAll('button');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          ksCall(event.currentTarget.getAttribute('data-act'));
        });
      }
    }
  }
  function ytPost(command) {
    var frame = document.getElementById('yt');
    if (!frame || !frame.contentWindow) return;
    try {
      frame.contentWindow.postMessage(JSON.stringify({event:'command', func:command, args:[]}), '*');
    } catch (e) {}
  }
  document.addEventListener('pointerdown', function(event) {
    if (fromChrome(event)) return;
    window.__ksY0 = event.clientY;
    window.__ksLastY = event.clientY;
  }, true);
  document.addEventListener('pointermove', function(event) {
    if (fromChrome(event)) return;
    if (window.__ksLastY == null) return;
    var dy = event.clientY - window.__ksLastY;
    window.__ksLastY = event.clientY;
    if (dy) ksCall('drag', dy);
  }, true);
  document.addEventListener('pointerup', function(event) {
    if (window.__ksY0 == null) return;
    var dy = event.clientY - window.__ksY0;
    window.__ksY0 = null;
    window.__ksLastY = null;
    var state = window.__ksTrailer || {};
    if ((state.expand || 0) > 0.62 && dy < -72) ksCall('close');
    ksCall('dragEnd');
  }, true);
  document.addEventListener('pointercancel', function() {
    window.__ksY0 = null;
    window.__ksLastY = null;
    ksCall('dragEnd');
  }, true);
  document.addEventListener('keydown', function(event) {
    var state = window.__ksTrailer || {};
    if ((event.key === 'Escape' || event.key === 'Esc') && (state.expand || 0) > 0.02) {
      event.preventDefault();
      if ((state.expand || 0) > 0.55) ksCall('close');
    }
  });
  window.__ksTrailerApply = function() {
    var state = window.__ksTrailer || {};
    var t = state.expand || 0;
    var video = document.querySelector('video');
    if (video) {
      video.muted = !!state.muted;
      video.playsInline = true;
      if (video.paused) {
        try {
          var pending = video.play();
          if (pending && pending.catch) pending.catch(function(){});
        } catch (e) {}
      }
      video.style.objectFit = t > 0.9 ? 'contain' : 'cover';
    } else if (window.ksSetAudible) {
      window.ksSetAudible(!state.muted);
    }
    if (window.ksSetExpanded) window.ksSetExpanded(t > 0.55);
    var scrim = document.getElementById('ks-scrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.id = 'ks-scrim';
      scrim.style.cssText = 'position:fixed;left:0;right:0;top:0;bottom:0;pointer-events:none;z-index:2147483646;';
      (document.body || document.documentElement).appendChild(scrim);
    }
    scrim.style.opacity = String(t > 0.2 ? 0 : 1);
    var solid = state.scrim || 'rgba(2,10,36,1)';
    var parts = /rgba\((\d+),(\d+),(\d+)/.exec(solid);
    scrim.style.background = parts
      ? 'linear-gradient(to bottom, rgba(' + parts[1] + ',' + parts[2] + ',' + parts[3] + ',0.3), rgba(' + parts[1] + ',' + parts[2] + ',' + parts[3] + ',1))'
      : 'linear-gradient(to bottom, transparent, ' + solid + ')';
    var back = button('ks-back', '\u2039', 'back');
    var close = button('ks-close', '\u00d7', 'close');
    back.style.display = state.showBack ? 'block' : 'none';
    close.style.display = state.showClose ? 'block' : 'none';
    close.style.left = 'auto';
    close.style.right = '12px';
    renderBanner(state);
    renderActions(state);
  };
  if (!window.__ksTrailerTimer) {
    var tries = 0;
    window.__ksTrailerTimer = setInterval(function() {
      if (window.__ksTrailerApply) window.__ksTrailerApply();
      if (++tries > 24) {
        clearInterval(window.__ksTrailerTimer);
        window.__ksTrailerTimer = 0;
      }
    }, 250);
  }
})();
"""
